<template>
  <div v-if="hasAuth('Finalizer')">
    <list-container :header="translate('circulationProfileSchema.targetSystems')"  v-show="!$route.params.id" :showSearch="true" @search="searchTargetSystems">
      <template v-slot:commands>
        <button type="button" style="margin-left: 10px;" class="btn btn-success " @click="$router.push({ name: 'TargetSystemImport' })">
          {{translate('externalSignerImport.importFromExcel2')}}
        </button>
        <excel-exporter
          table-id="targetsystemsExport"
          :columns="columns"
          url="/targetsystem/get"
          modelName="TargetSystem"
          :predicate="'IsSingleUse == false'"
          orderBy="Name"
        ></excel-exporter>
        <button
          class="btn btn-primary"
          @click="
            $router.push({
              name: 'TargetSystemDetail',
              params: { id: '000000000000000000000000' },
              query: { kind: 'Email' },
            })
          "
        >
        {{translate('targetSystem.newTargetSystem')}}
        </button>
      </template>
        <list
          ref="targetSystems"
          :columns="columns"
          url="/targetsystem/get"
          modelName="TargetSystem"
          :predicate="predicate"
          :filter="filter"
          orderBy="IsActive desc, Name"
        >
        </list>
    </list-container>
    <router-view v-if="$route.params.id"/>
  </div>
  <div v-else class="alert alert-danger">
    {{translate('errors.notAuthorizedForTheProcess')}}
  </div>
</template>

<script>
import list from "../components/List.vue";
import listContainer from "../components/ListContainer.vue";
import Vue from "vue";
import ExcelExporter from "../components/ExcelExporter.vue";
import i18n from "../i18n";
export default {
  data() {
    return {
      predicate: "IsSingleUse == false",
      searchText: "",
      filter: { DepartmentIds : this.hasAuth("Admin") ? [] : this.$root?.$data?.login?.User?.DepartmentIds ?? [] },
      columns: [
        {
          Key: "Name",
          Title: this.translate('customTargetSystem.targetName'),
          SortField: "Name",
        },
        {
          Key: "Kind",
          Title: this.translate('targetSystemImport.kind'),
          Content(i) {
            return Vue.filter("targetSystemKind")(i.Kind);
          },
        },
        {
          Key: "Mail",
          Title: this.translate('externalSignerImport.email'),
          SortField: "Mail",
        },
        {
          Key: "Department.Name",
          Title: this.translate('targetSystemImport.department'),
          Content(i) {
            return i.Department?.Name.cleanHtml() || i18n.t('circulationProfileSchema.departmentIndependent');
          },
        },
        {
          Key: "IsActive",
          Title: this.translate('targetSystemImport.active'),
          SortField: "IsActive",
          Class: "text-center",
          // Style: "width:1px",
          Content(i) {
            return Vue.filter("checkicon")(i.IsActive);
          },
        },
      ],
    };
  },
  components: {
    list,
    ExcelExporter,
    listContainer,
  },
  methods: {
    searchTargetSystems(searchText) {
      var parts = [];
      console.log(searchText);

      parts.push("IsSingleUse == false");

      if (searchText != "")
        parts.push(
          ` Name.ToLower().Contains("${searchText.toLowerCase()}")`
        );

      this.predicate = parts.join(" && ");
      this.$refs.targetSystems.predicate = this.predicate;
      this.$refs.targetSystems.getData();
    },
  },
};
</script>
<style scoped>
.col-search {
  margin-top: 20px;
  float: right;
  clear: both;
  width: 30%;
}
.mbm {
  margin-bottom: 10px !important;
}
.input-group-btn {
  padding-left: 10px;
  padding-top: 6px;
  padding-right: 10px;
  background-color: #e5e5e5;
  color: #777777;
  border-color: #e5e5e5;
  border: 1px solid #e5e5e5;
  position: relative;
  font-size: 0;
  white-space: nowrap;
}
</style>